module.exports = __webpack_public_path__ + "img/navigation-3.22764d6b.png";